import { EntityOption } from '@context/shared/types/common';
import { ChemicalRevision } from '../types';

export class ChemicalRevisionOption extends EntityOption<ChemicalRevision> {
	protected override toString() {
		return this.data.regulationNumber;
	}
}
